<ng-container *ngIf="iconTemplate">
  <div [ngClass]="cssIcon" [innerHTML]="iconTemplate | trustHtml"></div>
</ng-container>

<ng-container *ngIf="!iconTemplate">
  <mat-icon [svgIcon]="icon" [style]="{ width: width + 'px', height: height + 'px' }" [ngClass]="cssIcon"></mat-icon>
</ng-container>
